<template>
  <div class="transition-global tw-h-screen totemBG">
    <div class="customGrid tw-h-5/6">
      <div class="tw-text-center">
        <vLogoDefault />
      </div>
      <div class="tw-text-center tw-text-white tw-text-3xl">
        <div class="tw-py-5">
          <div class="tw-font-bold tw-text-5xl">Quantidade e valor</div>
          <div class="tw-pt-5 tw-text-4xl tw-w-2/3 tw-mx-auto">
            Escolha a quantidade de imagens e o valor a ser pago
          </div>
        </div>
        <div class="tw-p-5 tw-mt-28" v-if="getList.length == 0">
          Infelizmente estamos sem preços desse tipo de foto, basta voltar e
          selecionar outro tipo.
        </div>
        <div class="outSizeContainList" v-else>
          <div class="containsTypeList scroll-modern">
            <div
              class="tw-w-full"
              :key="index"
              v-for="(item, index) in getList"
            >
              <div
                class="sale-item tw-w-full tw-items-center tw-p-5 tw-text-white tw-cursor-pointer tw-font-normal tw-text-3xl tw-text-left tw-rounded-xl tw-transition-all tw-duration-150 tw-transform tw-relative"
                :class="{
                  'sale-item--featured':
                    item.id && item.id === precoMaisPedidoId,
                  'tw-opacity-100 gradientActiveItem tw-scale-105':
                    selectedItem == item,
                  'tw-opacity-60 gradientItem ': selectedItem != item,
                }"
                @click="selecionaItem(item)"
              >
                <span
                  v-if="item.id && item.id === precoMaisPedidoId"
                  class="sale-item__featured-badge"
                  role="img"
                  :aria-label="rotuloDestaque"
                  :title="rotuloDestaque"
                >
                  <span class="sale-item__featured-star" aria-hidden="true"
                    >★</span
                  >
                  <span aria-hidden="true">MAIS VENDIDA</span>
                </span>
                <div class="sale-item__quantity tw-pb-2">
                  <span class="tw-font-bold tw-mr-2">Fotos: </span>
                  {{ item.qtde_foto }}
                </div>
                <div class="tw-pt-2">
                  <span class="tw-font-bold tw-mr-2">Valor: </span
                  >{{ getPriceCurrency(item.valor) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vFloatguide :destinoBack="getRouterBack" :next="false" />
    <vTimeout :segundos="$root.getTimeoutName('QTDE_FOTO')" />
  </div>
</template>

<script>
import anime from "animejs/lib/anime.es.js";
//import tipoFoto from "@/constants/tipoFoto";
//import { hasId, getList } from "@/constants/tipoFoto";
import etapa from "@/constants/etapaCompra";
import { setEtapaCompra, setQtdValorCompra } from "../../service/firebase";
import vFloatguide from "@/components/floatGuide";
import posthog from "@/posthog";
import { buscarRecomendacaoItem } from "@/service/totemSaleRecommendation";
import { ehEvento } from "@/constants/types/tipoTotem";
export default {
  components: {
    vFloatguide,
  },
  data() {
    return {
      selectedItem: {},
      qtd: 0,
      precos: [],
      compra: {},
      precoMaisPedidoId: null,
      recomendacaoFonte: null,
    };
  },
  beforeMount() {
    this.compra = this.$store.getters["compra/getCompra"];
    let typePhoto = this.compra.tipo_foto;
    this.precos = this.$store.getters["precos/getPriceForType"](typePhoto);
    const totemId = this.$store.getters["totem/getTotem"]?.id;
    buscarRecomendacaoItem(totemId, this.precos, new Date(), typePhoto).then((recomendacao) => {
      this.precoMaisPedidoId = recomendacao?.precoId ?? null;
      this.recomendacaoFonte = recomendacao?.fonte ?? null;
    });
  },
  computed: {
    rotuloDestaque() {
      return this.recomendacaoFonte === "MANUAL"
        ? "Destaque escolhido neste totem"
        : "Foto mais pedida ontem";
    },
    getRouterBack() {
      return etapa.TIPO_FOTO;
    },
    getList() {
      const primeiras = this.precos.slice(0, 10);
      const destacada = this.precos.find(
        (item) => item.id === this.precoMaisPedidoId
      );
      return destacada && !primeiras.includes(destacada)
        ? [...primeiras, destacada]
        : primeiras;
    },
  },
  mounted() {
    this.animaMounted();
  },
  methods: {
    selecionaItem(item) {
      this.selectedItem = item;
      this.selectQtd(item);
    },
    getPriceCurrency(valor) {
      let currency = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(valor);
      return currency;
    },
    animaMounted() {
      anime({
        targets: ".transition-global",
        opacity: {
          value: 1,
          delay: 0,
          duration: 1000,
          easing: "easeInOutExpo",
        },
      });
    },
    selectQtd(preco) {
      let qtd = Number(preco.qtde_foto);
      let valor = Number(preco.valor);
      let codigoProduto = preco.codigo_produto || null;
      const selected = [qtd, valor, codigoProduto];
      if (ehEvento(this.$store.getters["totem/getTotem"]?.tipoTotem)) selected.push(preco.id);
      setQtdValorCompra(...selected)
        .then(() => {
          posthog.capture("photo_quantity_selected", {
            photo_quantity: qtd,
            purchase_value: valor,
          });
          // Escolher a quantidade antes da forma de envio. Sem câmera
          // configurada, o caminho da galeria continua direto para o QR.
          const totem = this.$store.getters["totem/getTotem"];
          if (totem.config?.selfie) {
            setEtapaCompra(etapa.MODO_CAPTURA);
          } else {
            setEtapaCompra(etapa.SCAN_QR_CODE);
          }
        })
        .catch((err) => {
          console.log(
            "Ocorreu um erro na hora de atualizar a qtd valor compra: ",
            err
          );
          this.$root.infoModal(
            "Ocorreu um erro na hora de atualizar a qtd valor compra"
          );
          this.selectedItem = {};
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.outSizeContainList {
  @apply tw-bg-black tw-bg-opacity-10 tw-mt-10 tw-justify-center tw-items-center;
}
.containsTypeList {
  max-height: clamp(28rem, 45vh, 52.5rem);
  overflow-x: auto;
  gap: clamp(0.5rem, 1.5vh, 1rem);
  @apply tw-grid tw-grid-cols-2 tw-p-5;
}
.scrollCustom {
  overflow-y: auto;
}
.gradientActiveItem {
  background: linear-gradient(180deg, #8c2667 0%, #222129 100%);
}
.gradientItem {
  background: linear-gradient(180deg, #8876a1 0%, #222129 100%);
}
.sale-item--featured {
  opacity: 1;
  background: linear-gradient(180deg, #514260 0%, #222129 100%);
  box-shadow: inset 0 0 0 3px rgba(252, 211, 77, 0.95),
    0 0 8px rgba(252, 211, 77, 0.35);
  animation: featured-item-pulse 2s ease-in-out infinite;
}
.sale-item--featured .sale-item__quantity {
  padding-right: clamp(128px, 24vw, 260px);
}
.sale-item__featured-badge {
  position: absolute;
  top: clamp(8px, 0.9vw, 12px);
  right: clamp(8px, 0.9vw, 12px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: clamp(4px, 0.75vw, 9px);
  width: clamp(128px, 24vw, 260px);
  min-height: clamp(28px, 5.2vw, 52px);
  padding: 2px clamp(6px, 1.1vw, 12px);
  border-radius: 999px;
  background: #fcd34d;
  color: #222129;
  font-size: clamp(12px, 2.25vw, 24px);
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  pointer-events: none;
}
.sale-item__featured-star {
  font-size: clamp(20px, 3.55vw, 36px);
  line-height: 1;
}
@media (max-width: 700px) {
  .sale-item--featured .sale-item__quantity {
    padding-right: 108px;
  }
  .sale-item__featured-badge {
    top: 8px;
    right: 8px;
    gap: 3px;
    width: 116px;
    min-height: 28px;
    padding: 2px 3px;
    font-size: 12px;
  }
  .sale-item__featured-star {
    font-size: 18px;
  }
}
@keyframes featured-item-pulse {
  0%,
  100% {
    box-shadow: inset 0 0 0 3px rgba(252, 211, 77, 0.95),
      0 0 8px rgba(252, 211, 77, 0.35);
    filter: brightness(1);
  }
  50% {
    box-shadow: inset 0 0 0 3px rgba(252, 211, 77, 1),
      0 0 18px rgba(252, 211, 77, 0.8);
    filter: brightness(1.18);
  }
}
@media (prefers-reduced-motion: reduce) {
  .sale-item--featured {
    animation: none;
  }
}
.customGrid {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
}
.groupitems {
  &::-webkit-scrollbar {
    width: 0px;
    opacity: 0;
  }
}
.transition-global {
  opacity: 0;
}
.totemBG {
  background-size: cover;
  background-image: linear-gradient(
      180deg,
      #978fc4 0%,
      #a78ebd 34.84%,
      rgba(207, 138, 172, 0.8) 100%
    ),
    url("../../assets/fundo.png");
}
</style>
